/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { headerOwnershipHolderDtoSchema } from "./headerOwnershipHolderDtoSchema.ts";
import { z } from "zod/v4";

export const headerOwnershipDtoSchema = z.object({
  foundersPct: z.optional(z.int()),
  investorsPct: z.optional(z.int()),
  esopPct: z.optional(z.int()),
  notes: z.optional(z.string()),
  get holders() {
    return z.array(headerOwnershipHolderDtoSchema).optional();
  },
  verifiedNote: z.optional(z.string()),
});
